export enum SupportedLanguages {
    ENGLISH,
    FRENCH
  }

export class AppConstants {
  static readonly INDUSTRY_CODES_TO_HIDE_ADS = ['LIB', 'UNI'];

  static readonly ENGLISH_CODE = 'en';
  static readonly FRENCH_CODE = 'fr';

  static readonly AUTH_SERVICE_CLIENT_ID = 'cps';
  static readonly AUTH_SERVICE_CLIENT_SECRET = 'secret';
  static readonly AUTH_SERVICE_PASSWORD_GRANT = 'password';
  static readonly AUTH_SERVICE_REFRESHTOKEN_GRANT = 'refresh_token';
  static readonly AUTH_SERVICE_AUTOLOGIN_GRANT = "autologin";

  static readonly AD_TYPE_MAPPING = 
    {'horizontal': 'TOP',
    'vertical': 'SIDE'};
}